import NewVerificationModal from './NewVerificationModal';

export { defaultReverificationVendor } from './NewVerificationModal';
export type { NewVerificationTab } from './types';
export default NewVerificationModal;
